import React, { useState } from 'react';

import ListAuthorizationConsents from '../shared/components/authorizations/ListAuthorizationConsents';
import ListAuthorizationTemplates from '../shared/components/authorizations/ListAuthorizationTemplates';
import SecondaryButton from '../shared/components/SecondaryButton';

const Authorizations = () => {
  const [showTemplates, setShowTemplates] = useState(true);

  return (
    <section>
      {/* Header */}
      <div className="md:pt-14 px-4 md:px-9">
        <div className="flex flex-col gap-4 border-b border-gray-admin pb-4 pt-11 md:pt-0 mb-6 md:flex-row md:items-center md:justify-between">
          <div>
            <h3 className="font-bold text-xl">Autorisations</h3>
            <p className="text-sm text-gray-500">
              Modèles d’autorisations et documents signés
            </p>
          </div>

          {/* Switch buttons */}
          <div className="flex gap-2">
            <SecondaryButton
              title="Modèles"
              active={showTemplates}
              onClick={() => setShowTemplates(true)}
            />
            <SecondaryButton
              title="Autorisations créées"
              active={!showTemplates}
              onClick={() => setShowTemplates(false)}
            />
          </div>
        </div>
      </div>

      {/* Content */}
      {showTemplates ? (
        <ListAuthorizationTemplates />
      ) : (
        <ListAuthorizationConsents />
      )}
    </section>
  );
};

export default Authorizations;
